import { AUTH_COOKIES } from '@nutralab/api';

/** Whether the session cookie is set, i.e. the server part was rendered for a signed-in user. */
export function hasAuthCookie(): boolean {
    return document.cookie.split('; ').some((entry) => entry.startsWith(`${AUTH_COOKIES.ACCESS}=`));
}
